import {NgModule} from '@angular/core';
import {HbConfigPage} from "./page/overview/hc-config/hb-config.page";
import {HB_ENTITY_PROVIDER} from "./hb.entity-provider";
import {CoreModule} from "../../core/core.module";
import {IntegrationBiproVersionObjectComponent} from "./component/integration-bipro-version-object/integration-bipro-version-object.component";
import {IntegrationBiproTemplateObjectComponent} from "./component/integration-bipro-template-object/integration-bipro-template-object.component";


@NgModule({
  declarations: [
    HbConfigPage,
    IntegrationBiproVersionObjectComponent,
    IntegrationBiproTemplateObjectComponent
  ],
  exports:[
    HbConfigPage,
    IntegrationBiproVersionObjectComponent,
    IntegrationBiproTemplateObjectComponent
  ],
  imports: [
    CoreModule,

  ],
  providers: [HB_ENTITY_PROVIDER]
})
export class HbModule { }
 
 
 
